.wrapper {
  box-sizing: border-box;
  padding: var(--rc-theme-spacing-xs) var(--rc-theme-spacing-ms);
  border: var(--rc-theme-border-base);
  border-radius: var(--rc-theme-border-radius-base);
  background-color: var(--rc-theme-color-surface-subtle);

  &:not(:last-of-type) {
    margin-bottom: var(--rc-theme-spacing-xxs);
  }
}

.shrink {
  min-width: 0;
  overflow: hidden;
}
